module.exports = __webpack_public_path__ + "static/media/half-banner-1.c725fa1b.svg";